import i18n from 'config/i18n';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

const activitySchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup.object({
    name: yup
      .string()
      .trim()
      .required(t('validationFieldRequired', { name: t('name') })),
    code: yup
      .string()
      .trim()
      .required(t('validationFieldRequired', { name: t('code') })),
    description: yup.string().notRequired(),
    qualifications: yup
      .array()
      .of(
        yup.object({
          id: yup.string().required(),
          name: yup.string(),
          code: yup.string()
        })
      )
      .default([]),
    functions: yup
      .array()
      .of(
        yup.object({
          id: yup.string().required(),
          name: yup.string().required()
        })
      )
      .default([])
  });
};

export default activitySchema;
